export const phrasesLocalStorageKey = 'ft-phrases-v1.0';
export const npsLocalStorageKey = 'enable_nps';
